// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import SubjectAreaListResultModel from '../../model/subject-area-list-result-model';
import SubjectAreaListResultDTO from '../dto/subject-area-list-result-dto';
import dtoSchema from '../schemas/subject-area-list-result-schema';
import SubjectAreaModel from '../../model/subject-area-model';
import ResourceLinkModel from '../../model/resource-link-model';

export default abstract class SubjectAreaListResultModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<SubjectAreaListResultDTO>) {
    super();
    if (data) {
      this.items = data.items?.map((i) => SubjectAreaModel.toModel(i)) ?? [];
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
    }
  }
  /**
  */
  items?: SubjectAreaModel[];
  /**
  */
  links?: ResourceLinkModel[];

  static toModel(dto: DeepPartial<SubjectAreaListResultDTO>): SubjectAreaListResultModel;
  static toModel(dto: DeepPartial<SubjectAreaListResultDTO> | undefined | null): SubjectAreaListResultModel | undefined;
  static toModel(dto: DeepPartial<SubjectAreaListResultDTO> | undefined | null): SubjectAreaListResultModel | undefined {
    return dto ? new SubjectAreaListResultModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<SubjectAreaListResultModel> | SubjectAreaListResultModel): SubjectAreaListResultDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      items: unwrapped.items,
      links: unwrapped.links,
    } as SubjectAreaListResultDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for SubjectAreaListResultModel, can not map to SubjectAreaListResultDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
